import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import { loadReport } from "../thunks/loadReportDateData";
import { AnnualTradingReportData } from "../types";
import { setData } from "../annualTradeDataSlice";

export const useReportDateData = () => {
  const data = useSelector<StoreType, AnnualTradingReportData[] | undefined>(
    (s) => s.data.reports.annualTrade.data
  );

  const dispatch = useDispatch();
  const dispatchLoadData = React.useCallback(() => dispatch(loadReport()), [
    dispatch,
  ]);

  const resetData = React.useCallback(() => {
    dispatch(setData(undefined));
  }, [dispatch]);

  return [data, dispatchLoadData, resetData] as [
    typeof data,
    typeof dispatchLoadData,
    typeof resetData
  ];
};
